/**
 * Handler para el segundo swatch de colores (data-swatch-item2)
 * Basado en la lógica del swatch original pero adaptado para el segundo swatch
 */
(function ($) {
  'use strict';

  // Flag para prevenir múltiples cargas simultáneas
  var isLoadingProduct = false;
  var lastLoadedProductUrl = null;
  var selectedColorInfo = null; // Guardar información del color seleccionado

  // Esperar a que el DOM esté listo
  $(document).ready(function () {
    initSwatch2();
    initHistoryHandler();
  });

  /**
   * Maneja el historial del navegador (botones atrás/adelante)
   */
  function initHistoryHandler() {
    // Escuchar cambios en el historial (botones atrás/adelante)
    window.addEventListener('popstate', function (event) {
      // Cuando el usuario usa los botones del navegador, recargar el producto
      var currentUrl = window.location.pathname;

      // Verificar si es una URL de producto
      if (currentUrl.indexOf('/products/') !== -1) {
        console.log('Navegación del historial detectada, recargando producto:', currentUrl);
        loadProductWithAJAX(currentUrl, null);
      }
    });
  }

  function initSwatch2() {
    // Selector para los elementos del segundo swatch
    var selector = '[data-swatch-item2]';

    // Verificar si hay elementos
    var $swatches = $(selector);

    if ($swatches.length === 0) {
      // Reintentar después de un delay si no hay elementos
      setTimeout(initSwatch2, 500);
      return;
    }

    // Detectar y seleccionar el color correspondiente al producto actual con un pequeño delay
    // para asegurar que el DOM esté listo y otros scripts no lo sobrescriban
    setTimeout(detectAndSelectCurrentProductColor, 200);

    // Registrar evento de clic usando delegación de eventos
    $(document).off('click.swatch2', selector).on('click.swatch2', selector, function (e) {
      e.preventDefault();
      e.stopPropagation();

      handleSwatch2Click($(this), true); // true = es un clic

      return false;
    });

    // Para dispositivos no táctiles, también registrar hover (solo para selección visual, NO para cargar producto)
    if (!isTouchDevice()) {
      // Usar delegación para mouseleave para asegurar que los tooltips se gestionen bien
      $(document).on('mouseleave.swatch2', selector, function () {
        // Al salir del hover, forzar al tema a ocultar el tooltip
        hideAllTooltips();
      });

      // Mantener hoverIntent si existe para una transición más suave, pero con limpieza extra
      if (typeof $.fn.hoverIntent !== 'undefined') {
        $(document).hoverIntent({
          selector: selector,
          sensitivity: 6,
          interval: 100,
          timeout: 100,
          over: function () {
            // No hacer nada en hover
          },
          out: function () {
            hideAllTooltips();
          }
        });
      }
    }
  }

  /**
   * Detecta y selecciona automáticamente el color correspondiente al producto actual
   */
  function detectAndSelectCurrentProductColor() {
    // Obtener información del producto actual
    var currentProductUrl = window.location.pathname;
    var currentProductHandle = '';
    var currentProductId = '';

    // Intentar obtener el ID del producto desde el DOM
    var $productForm = $('[data-productid]');
    if ($productForm.length > 0) {
      currentProductId = $productForm.data('productid') || $productForm.attr('data-productid') || '';
    }

    // Extraer handle de la URL (formato: /products/handle)
    var urlMatch = currentProductUrl.match(/\/products\/([^\/\?]+)/);
    if (urlMatch && urlMatch[1]) {
      currentProductHandle = urlMatch[1];
    }

    console.log('🔍 Detectando color para producto actual:', {
      url: currentProductUrl,
      handle: currentProductHandle,
      id: currentProductId
    });

    // Buscar el swatch que tenga este producto asociado
    var $swatches = $('[data-swatch-item2]');
    var $matchingSwatch = null;

    $swatches.each(function () {
      var $swatch = $(this);
      var swatchProductId = $swatch.data('color-producto-id') || $swatch.attr('data-color-producto-id') || '';
      var swatchProductUrl = $swatch.data('color-producto-url') || $swatch.attr('data-color-producto-url') || '';
      var swatchProductHandle = $swatch.data('color-producto-handle') || $swatch.attr('data-color-producto-handle') || '';

      // Comparar primero por ID (más fiable)
      if (currentProductId && swatchProductId && currentProductId.toString() === swatchProductId.toString()) {
        $matchingSwatch = $swatch;
        return false;
      }

      // Fallback: Comparar por URL o handle
      var matches = false;

      if (currentProductUrl && swatchProductUrl) {
        // Normalizar URLs para comparar
        var normalizedCurrent = currentProductUrl.replace(/\/$/, ''); // Quitar trailing slash
        var normalizedSwatch = swatchProductUrl.replace(/\/$/, '');
        matches = matches || normalizedCurrent === normalizedSwatch ||
          normalizedCurrent.indexOf(normalizedSwatch) !== -1 ||
          normalizedSwatch.indexOf(normalizedCurrent) !== -1;
      }

      if (currentProductHandle && swatchProductHandle) {
        matches = matches || currentProductHandle.toLowerCase() === swatchProductHandle.toLowerCase();
      }

      if (matches) {
        $matchingSwatch = $swatch;
        return false; // Salir del each
      }
    });

    // Si se encontró un swatch coincidente, seleccionarlo
    if ($matchingSwatch && $matchingSwatch.length > 0) {
      var $swatchOption = $matchingSwatch.closest('[data-swatch-option2]');

      if ($swatchOption.length > 0) {
        // Remover selección anterior
        $swatchOption.find('[data-swatch-item2]').removeClass('is--selected');

        // Agregar selección al color encontrado
        $matchingSwatch.addClass('is--selected');

        // Actualizar el texto mostrado
        var colorNombre = $matchingSwatch.data('color-nombre') || $matchingSwatch.attr('data-color-nombre') || '';
        var selectedValue = $matchingSwatch.data('value') || $matchingSwatch.attr('data-value') || '';
        var displayText = colorNombre || selectedValue;

        $swatchOption.find('[data-current-value2]').text(displayText);
        $swatchOption.find('.t4s-dropdown__title').text(displayText);

        console.log('✅ Color detectado y seleccionado automáticamente:', displayText);
      }
    } else {
      console.log('ℹ️ No se encontró un color que coincida con el producto actual');
    }
  }

  /**
   * Maneja el hover sobre un swatch (solo actualización visual, NO carga producto)
   */
  function handleSwatch2Hover($this) {
    // Función vacía: ya no actualizamos el texto en hover por petición del usuario
  }

  /**
   * Oculta todos los tooltips visibles
   */
  function hideAllTooltips() {
    // Usar el evento del tema para ocultar tooltips
    if (typeof $ !== 'undefined' && $.fn.trigger) {
      $('body').trigger('t4s:hideTooltip');
    }

    // También ocultar manualmente cualquier tooltip que pueda quedar
    $('.t4s-tooltip.is--show').removeClass('is--show').remove();

    // Limpiar aria-describedby de elementos que puedan tener tooltips activos
    $('[aria-describedby^="tooltipt4s"]').removeAttr('aria-describedby');
  }

  /**
   * Maneja el clic en un swatch (carga el producto si tiene uno asociado)
   */
  function handleSwatch2Click($this, isClick) {
    isClick = isClick || false; // Por defecto, asumir que no es clic

    // Si el producto está agotado, no permitir el clic
    if ($this.hasClass('is--soldout')) {
      console.log('🚫 Producto agotado, ignorando clic');
      return;
    }

    // Obtener el contenedor del producto
    var $product = $this.closest('.t4s-product-form__variants');

    if ($product.length === 0) {
      return;
    }

    // Obtener el formulario y el select de variantes
    var $form = $product.find('form');
    var $select = $form.find('select[name="id"]');

    if ($select.length === 0) {
      return;
    }

    // Obtener datos del elemento clickeado
    var selectedValue = $this.data('value') || $this.attr('data-value');
    var colorNombre = $this.data('color-nombre') || $this.attr('data-color-nombre') || selectedValue;
    var colorTexto = $this.data('color-texto') || $this.attr('data-color-texto') || selectedValue;

    // Verificar si hay un producto asociado para redirigir
    var productUrl = $this.data('color-producto-url') || $this.attr('data-color-producto-url');
    var productHandle = $this.data('color-producto-handle') || $this.attr('data-color-producto-handle');
    var productId = $this.data('color-producto-id') || $this.attr('data-color-producto-id');

    // Solo cargar producto si es un clic explícito Y hay un producto asociado
    if (isClick && (productUrl && productUrl !== '' || productHandle && productHandle !== '')) {
      var targetUrl = productUrl || '/products/' + productHandle;

      // Prevenir múltiples cargas simultáneas o cargar el mismo producto
      if (isLoadingProduct) {
        console.log('⏳ Ya hay una carga en progreso, ignorando...');
        return;
      }

      if (lastLoadedProductUrl === targetUrl) {
        console.log('ℹ️ Este producto ya está cargado, ignorando...');
        return;
      }

      console.log('=== Cargando producto con AJAX ===');
      console.log('URL del producto:', targetUrl);
      console.log('Handle del producto:', productHandle);

      // Guardar información del color seleccionado antes de cargar
      selectedColorInfo = {
        colorNombre: colorNombre,
        colorTexto: colorTexto,
        selectedValue: selectedValue,
        colorHex: $this.data('color-hex') || $this.attr('data-color-hex') || '',
        productUrl: productUrl,
        productHandle: productHandle
      };

      console.log('💾 Color seleccionado guardado:', selectedColorInfo);

      loadProductWithAJAX(targetUrl, productHandle, selectedColorInfo);
      return; // Salir para evitar que se ejecute la lógica de selección de variante si se redirige
    }

    // Obtener el contenedor de la opción del swatch
    var $swatchOption = $this.closest('[data-swatch-option2]');
    var isMetaSwatch = $swatchOption.length > 0 && ($swatchOption.data('meta-swatch') || $swatchOption.attr('data-meta-swatch') === 'true');
    var optionIndex = $swatchOption.length > 0 ? ($swatchOption.data('id') || parseInt($swatchOption.attr('data-id')) || 0) : 0;

    // Actualizar el texto mostrado
    var displayText = colorNombre || selectedValue;
    if ($swatchOption.length > 0) {
      $swatchOption.find('[data-current-value2]').text(displayText);
      $swatchOption.find('.t4s-dropdown__title').text(displayText);
    }

    // Remover selección anterior y agregar nueva
    if ($swatchOption.length > 0) {
      $swatchOption.find('[data-swatch-item2]').removeClass('is--selected');
    }
    $this.addClass('is--selected');

    // Buscar y seleccionar la variante correspondiente
    var newVariant = null;

    if (isMetaSwatch) {
      // Para swatches de metaobjeto, buscar por nombre del color
      $select.find('option').each(function () {
        var $opt = $(this);
        var optText = $opt.text().toLowerCase();
        var optValue = $opt.val();

        // Comparar con el nombre del color, texto o valor seleccionado
        if (optText.indexOf(selectedValue.toLowerCase()) >= 0 ||
          optText.indexOf(colorNombre.toLowerCase()) >= 0 ||
          optText.indexOf(colorTexto.toLowerCase()) >= 0) {
          newVariant = optValue;
          return false; // Salir del each
        }
      });
    } else {
      // Para swatches normales, buscar por índice de opción
      $select.find('option').each(function () {
        var $opt = $(this);
        var optText = $opt.text();
        var optParts = optText.split(' / ');

        if (optParts[optionIndex] === selectedValue) {
          newVariant = $opt.val();
          return false; // Salir del each
        }
      });
    }

    // Si se encontró una variante, seleccionarla
    if (newVariant) {
      $select.val(newVariant).trigger('change');
    }
  }

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  /**
   * Carga un producto completo usando AJAX sin recargar la página
   * @param {string} productUrl - URL completa del producto
   * @param {string} productHandle - Handle del producto (opcional)
   * @param {object} colorInfo - Información del color seleccionado (opcional)
   */
  function loadProductWithAJAX(productUrl, productHandle, colorInfo) {
    // Prevenir múltiples cargas simultáneas
    if (isLoadingProduct) {
      console.log('⏳ Ya hay una carga en progreso, ignorando...');
      return;
    }

    // Marcar como cargando
    isLoadingProduct = true;
    lastLoadedProductUrl = productUrl;

    // Mostrar indicador de carga
    // showLoadingIndicator();

    console.log('🔄 Iniciando carga de producto:', productUrl);

    // Hacer fetch del producto
    fetch(productUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Error al cargar el producto: ' + response.status);
        }
        return response.text();
      })
      .then(function (html) {
        // Parsear el HTML
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Ocultar todos los tooltips antes de actualizar el contenido
        hideAllTooltips();

        // Actualizar todas las secciones de la página

        // 1. Actualizar la sección principal del producto
        var newProductContainer = doc.querySelector('.t4s-main-product__content');
        var currentProductContainer = document.querySelector('.t4s-main-product__content');
        if (newProductContainer && currentProductContainer) {
          currentProductContainer.innerHTML = newProductContainer.innerHTML;
          console.log('✅ Sección principal del producto actualizada');
        }

        // 2. Actualizar sección de productos recomendados
        var newRecommendations = doc.querySelector('[data-section-type="product-recommendations"]');
        var currentRecommendations = document.querySelector('[data-section-type="product-recommendations"]');
        if (newRecommendations && currentRecommendations) {
          currentRecommendations.innerHTML = newRecommendations.innerHTML;
          console.log('✅ Productos recomendados actualizados');
        }

        // 3. Actualizar sección de productos vistos recientemente
        var newRecentlyViewed = doc.querySelector('[data-section-type="recently_viewed"]');
        var currentRecentlyViewed = document.querySelector('[data-section-type="recently_viewed"]');
        if (newRecentlyViewed && currentRecentlyViewed) {
          currentRecentlyViewed.innerHTML = newRecentlyViewed.innerHTML;
          console.log('✅ Productos vistos recientemente actualizados');
        }

        // 4. Actualizar todas las secciones con clase t4s-section que no sean main-product
        var allSections = doc.querySelectorAll('.t4s-section:not(.t4s-section-main-product)');
        allSections.forEach(function (newSection) {
          // Intentar encontrar la sección actual por ID o clase
          var sectionId = newSection.id || '';
          var sectionClass = newSection.className || '';

          // No actualizar secciones que son parte del header o footer para evitar saltos visuales o problemas con el carrito
          if (sectionId.indexOf('header') !== -1 ||
            sectionId.indexOf('announcement') !== -1 ||
            sectionId.indexOf('top-bar') !== -1 ||
            sectionId.indexOf('mega-menu') !== -1 ||
            sectionId.indexOf('footer') !== -1 ||
            sectionId.indexOf('announce-envios') !== -1 ||
            sectionId.indexOf('bottom-bar') !== -1) {
            console.log('⏭️ Saltando actualización de sección (header/footer):', sectionId);
            return;
          }

          if (sectionId) {
            var currentSection = document.getElementById(sectionId);
            if (currentSection) {
              currentSection.innerHTML = newSection.innerHTML;
              console.log('✅ Sección actualizada:', sectionId);
            }
          } else {
            // Buscar por tipo de sección
            var sectionType = newSection.getAttribute('data-section-type');
            if (sectionType) {
              var currentSection = document.querySelector('[data-section-type="' + sectionType + '"]');
              if (currentSection && !currentSection.classList.contains('t4s-section-main-product')) {
                currentSection.innerHTML = newSection.innerHTML;
                console.log('✅ Sección actualizada:', sectionType);
              }
            }
          }
        });

        // 5. Actualizar breadcrumb si existe
        var newBreadcrumb = doc.querySelector('.t4s-breadcrumb, [data-section-type*="breadcrumb"], [data-section-type*="brc"]');
        var currentBreadcrumb = document.querySelector('.t4s-breadcrumb, [data-section-type*="breadcrumb"], [data-section-type*="brc"]');
        if (newBreadcrumb && currentBreadcrumb) {
          currentBreadcrumb.innerHTML = newBreadcrumb.innerHTML;
          console.log('✅ Breadcrumb actualizado');
        }

        // 6. Actualizar título de la página (document.title)
        var newTitle = doc.querySelector('title');
        if (newTitle) {
          document.title = newTitle.textContent;
        }

        // 7. Actualizar meta tags importantes
        var newMetaDescription = doc.querySelector('meta[name="description"]');
        var currentMetaDescription = document.querySelector('meta[name="description"]');
        if (newMetaDescription && currentMetaDescription) {
          currentMetaDescription.setAttribute('content', newMetaDescription.getAttribute('content'));
        }

        // Actualizar la URL sin recargar la página
        if (productUrl) {
          window.history.pushState({}, '', productUrl);
        } else if (productHandle) {
          var newUrl = '/products/' + productHandle;
          window.history.pushState({}, '', newUrl);
        }

        // Ocultar indicador de carga
        // hideLoadingIndicator();

        // Reinicializar scripts y componentes del tema
        reinitializeThemeComponents(colorInfo);

        // Marcar como terminado
        isLoadingProduct = false;

        console.log('✅ Toda la página del producto cargada exitosamente con AJAX');
      })
      .catch(function (error) {
        console.error('❌ Error al cargar el producto:', error);
        // hideLoadingIndicator();

        // Marcar como terminado (incluso si falló)
        isLoadingProduct = false;
        lastLoadedProductUrl = null; // Reset para permitir reintento

        // Fallback: redirigir normalmente si falla AJAX
        if (productUrl) {
          window.location.href = productUrl;
        } else if (productHandle) {
          window.location.href = '/products/' + productHandle;
        }
      });
  }

  /**
   * Muestra un indicador de carga mientras se carga el producto
   */
  // function showLoadingIndicator() {
  //   // Crear overlay de carga si no existe
  //   var $loadingOverlay = $('.t4s-product-ajax-loading');
  //   
  //   if ($loadingOverlay.length === 0) {
  //     $loadingOverlay = $('<div class="t4s-product-ajax-loading" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(255, 255, 255, 0.9); z-index: 9999; display: flex; align-items: center; justify-content: center; flex-direction: column;">' +
  //       '<div class="t4s-spinner" style="width: 50px; height: 50px; border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; animation: spin 1s linear infinite;"></div>' +
  //       '<p style="margin-top: 20px; font-size: 16px; color: #333;">Cargando producto...</p>' +
  //       '<style>@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style>' +
  //       '</div>');
  //     $('body').append($loadingOverlay);
  //   }
  //   
  //   $loadingOverlay.fadeIn(200);
  // }

  /**
   * Oculta el indicador de carga
   * COMENTADO: Desactivado según solicitud del usuario
   */
  // function hideLoadingIndicator() {
  //   var $loadingOverlay = $('.t4s-product-ajax-loading');
  //   if ($loadingOverlay.length > 0) {
  //     $loadingOverlay.fadeOut(200, function() {
  //       $(this).remove();
  //     });
  //   }
  // }

  /**
   * Reinicializa los componentes del tema después de cargar el producto
   * @param {object} colorInfo - Información del color seleccionado (opcional)
   */
  function reinitializeThemeComponents(colorInfo) {
    console.log('Reinicializando componentes del tema...');

    // Esperar un momento para que el DOM se actualice
    setTimeout(function () {
      // Reinicializar el Product principal (maneja la sincronización entre carrusel y thumbnails)
      var $productFeatured = $('[data-product-featured]');
      if ($productFeatured.length > 0 && typeof T4SThemeSP !== 'undefined' && typeof T4SThemeSP.Product !== 'undefined') {
        // Remover la clase enabled si existe para forzar reinicialización
        $productFeatured.removeClass('is--product-enabled');

        // Inicializar el Product principal
        if ($productFeatured[0] && !$productFeatured.hasClass('is--product-enabled')) {
          $productFeatured.addClass('is--product-enabled');
          new T4SThemeSP.Product($productFeatured[0]);
          console.log('✅ Product principal inicializado');
        }
      }

      // Reinicializar el carrusel de imágenes principal
      var $mainMedia = $('[data-main-media]');
      if ($mainMedia.length > 0 && typeof T4SThemeSP !== 'undefined' && typeof T4SThemeSP.Carousel !== 'undefined') {
        $mainMedia.each(function () {
          var $media = $(this);

          // Si tiene clase flickityt4s pero no está habilitado, inicializarlo
          if ($media.hasClass('flickityt4s') && !$media.hasClass('flickityt4s-enabled')) {
            // Destruir instancia anterior si existe
            if (this.flickityt4s && typeof this.flickityt4s.destroy === 'function') {
              try {
                this.flickityt4s.destroy();
              } catch (e) {
                console.warn('Error al destruir carrusel anterior:', e);
              }
            }

            // Crear nueva instancia del carrusel
            this.flickityt4s = new T4SThemeSP.Carousel(this);
            console.log('✅ Carrusel principal inicializado');
          }

          // Si tiene clase isotopet4s-later, también inicializarlo
          if ($media.hasClass('isotopet4s-later') && !$media.hasClass('isotopet4s-enabled')) {
            // El isotopet4s se inicializa automáticamente cuando se carga
            // pero podemos forzar la inicialización si es necesario
            console.log('✅ Isotope detectado');
          }
        });
      }

      // Reinicializar thumbnails si existen
      var $thumbNav = $('.t4s-carousel__nav, [data-thumb__scroller]');
      if ($thumbNav.length > 0 && typeof T4SThemeSP !== 'undefined' && typeof T4SThemeSP.Carousel !== 'undefined') {
        $thumbNav.each(function () {
          var $thumb = $(this);

          // Si tiene clase flickityt4s pero no está habilitado, inicializarlo
          if ($thumb.hasClass('flickityt4s') && !$thumb.hasClass('flickityt4s-enabled')) {
            // Destruir instancia anterior si existe
            if (this.flickityt4s && typeof this.flickityt4s.destroy === 'function') {
              try {
                this.flickityt4s.destroy();
              } catch (e) {
                console.warn('Error al destruir thumbnails anterior:', e);
              }
            }

            // Crear nueva instancia del carrusel de thumbnails
            this.flickityt4s = new T4SThemeSP.Carousel(this);
            console.log('✅ Thumbnails inicializados');
          }
        });
      }

      // Reinicializar swatch2
      initSwatch2();

      // Reinicializar otros componentes del tema si están disponibles
      if (typeof T4SThemeSP !== 'undefined') {
        // Reinicializar ProductItem
        if (typeof T4SThemeSP.ProductItem !== 'undefined' && typeof T4SThemeSP.ProductItem.init === 'function') {
          T4SThemeSP.ProductItem.init();
        }

        // Reinicializar ProductAjax
        if (typeof T4SThemeSP.ProductAjax !== 'undefined' && typeof T4SThemeSP.ProductAjax.init === 'function') {
          T4SThemeSP.ProductAjax.init();
        }

        // Reinicializar swatches
        if (typeof T4SThemeSP.ProductItem !== 'undefined' && typeof T4SThemeSP.ProductItem.swatchesClickHover === 'function') {
          T4SThemeSP.ProductItem.swatchesClickHover();
        }

        // Reinicializar PhotoSwipe para galería
        if (typeof T4SThemeSP.PhotoSwipe !== 'undefined' && typeof T4SThemeSP.PhotoSwipe.gallery === 'function') {
          T4SThemeSP.PhotoSwipe.gallery();
        }

        // Reinicializar resize observer
        if (typeof T4SThemeSP.ProductItem !== 'undefined' && typeof T4SThemeSP.ProductItem.resizeObserver === 'function') {
          T4SThemeSP.ProductItem.resizeObserver();
        }

        // Reinicializar RenderRefresh
        if (typeof T4SThemeSP.RenderRefresh !== 'undefined' && typeof T4SThemeSP.RenderRefresh === 'function') {
          T4SThemeSP.RenderRefresh();
        }

        // Reinicializar initGroupsProduct
        if (typeof T4SThemeSP.initGroupsProduct === 'function') {
          T4SThemeSP.initGroupsProduct();
        }

        // Reinicializar productos recomendados
        if (typeof T4SThemeSP.productRecommendations === 'function') {
          T4SThemeSP.productRecommendations();
        }

        // Reinicializar productos vistos recientemente
        if (typeof T4SThemeSP.recentlyViewed === 'function') {
          T4SThemeSP.recentlyViewed();
        }

        // Reinicializar reinitProductGridItem para productos en secciones
        if (typeof T4SThemeSP.reinitProductGridItem === 'function') {
          T4SThemeSP.reinitProductGridItem();
        }

        // Reinicializar Tabs (importante para que funcionen las tabs después de cargar producto)
        if (typeof T4SThemeSP.Tabs !== 'undefined' && typeof T4SThemeSP.Tabs.Accordion === 'function') {
          T4SThemeSP.Tabs.Accordion();
          console.log('✅ Tabs reinicializadas');
        }

        // Reinicializar Tooltips (importante para que funcionen los tooltips después de cargar producto)
        if (typeof T4SThemeSP.Tooltip !== 'undefined' && typeof T4SThemeSP.Tooltip === 'function') {
          // Remover la clase t4s-tooltip-actived de todos los elementos para forzar reinicialización
          $('[data-tooltip].t4s-tooltip-actived').removeClass('t4s-tooltip-actived');
          T4SThemeSP.Tooltip();
          console.log('✅ Tooltips reinicializados');
        }
      }

      // Reinicializar event listeners de tabs manualmente
      // Prevenir que los enlaces de tabs recarguen la página después de AJAX
      setTimeout(function () {
        var $tabItems = $('[data-t4s-tab-item]');
        if ($tabItems.length > 0) {
          // Remover listeners anteriores para evitar duplicados
          $tabItems.off('click.tabs-ajax-fix');

          // Agregar nuevos listeners que previenen el comportamiento por defecto
          $tabItems.on('click.tabs-ajax-fix', function (e) {
            var $this = $(this);
            var href = $this.attr('href') || '';

            // Solo prevenir si el href es un hash (tab interna)
            if (href && href.indexOf('#') === 0) {
              e.preventDefault();
              e.stopPropagation();

              // Verificar si el tab content existe
              var $target = $(href);
              if ($target.length > 0) {
                var $tabWrapper = $this.closest('[data-t4s-tabs]');
                var $tabItemWrapper = $this.closest('[data-t4s-tab-wrapper]'); // Wrapper del tab individual

                if ($tabWrapper.length > 0) {
                  // Verificar si el tab ya está abierto (toggle)
                  var isCurrentlyActive = $this.hasClass('t4s-active') &&
                    $target.hasClass('t4s-active') &&
                    $target.is(':visible') &&
                    ($tabItemWrapper.length === 0 || $tabItemWrapper.hasClass('t4s-active'));

                  if (isCurrentlyActive) {
                    // Cerrar el tab si ya está abierto (con animación)
                    $this.removeClass('t4s-active');
                    if ($tabItemWrapper.length > 0) {
                      $tabItemWrapper.removeClass('t4s-active');
                    }
                    $target.removeClass('t4s-active').slideUp(350); // Animación suave
                    console.log('✅ Tab cerrado:', href);
                  } else {
                    // Abrir el tab si está cerrado
                    // Verificar si es diseño accordion (permite múltiples abiertos) o tab (solo uno)
                    var isAccordion = $tabWrapper.hasClass('t4s-type-accordion') ||
                      $tabWrapper.hasClass('is--tab-design__accordion') ||
                      $tabWrapper.attr('data-t4s-accordion-pr') !== undefined;

                    if (!isAccordion) {
                      // Si es diseño tab, cerrar otros tabs primero (con animación)
                      $tabWrapper.find('[data-t4s-tab-item]').each(function () {
                        var $otherItem = $(this);
                        var otherHref = $otherItem.attr('href') || '';
                        var $otherTarget = $(otherHref);
                        var $otherWrapper = $otherItem.closest('[data-t4s-tab-wrapper]');

                        if ($otherItem.hasClass('t4s-active')) {
                          $otherItem.removeClass('t4s-active');
                          if ($otherWrapper.length > 0) {
                            $otherWrapper.removeClass('t4s-active');
                          }
                          $otherTarget.removeClass('t4s-active').slideUp(350);
                        }
                      });
                    }

                    // Activar el tab clickeado (con animación)
                    $this.addClass('t4s-active');
                    if ($tabItemWrapper.length > 0) {
                      $tabItemWrapper.addClass('t4s-active');
                    }
                    $target.addClass('t4s-active').slideDown(350); // Animación suave
                    console.log('✅ Tab abierto:', href);
                  }
                }
              }

              return false;
            }
          });

          console.log('✅ Event listeners de tabs reinicializados:', $tabItems.length, 'tabs encontradas');
        }
      }, 100); // Pequeño delay para asegurar que el DOM esté listo

      // Reinicializar carruseles en otras secciones (productos recomendados, etc.)
      var $otherCarousels = $('.flickityt4s:not([data-main-media])');
      $otherCarousels.each(function () {
        if ($(this).hasClass('flickityt4s-later') && !$(this).hasClass('flickityt4s-enabled')) {
          if (typeof T4SThemeSP !== 'undefined' && typeof T4SThemeSP.Carousel !== 'undefined') {
            // Destruir instancia anterior si existe
            if (this.flickityt4s && typeof this.flickityt4s.destroy === 'function') {
              try {
                this.flickityt4s.destroy();
              } catch (e) {
                console.warn('Error al destruir carrusel anterior:', e);
              }
            }
            // Crear nueva instancia
            this.flickityt4s = new T4SThemeSP.Carousel(this);
            console.log('✅ Carrusel de sección reinicializado');
          }
        }
      });

      // Disparar evento personalizado para que otros scripts puedan escuchar
      $(document).trigger('product:loaded:ajax');

      // Restaurar la selección del color después de cargar el producto
      if (colorInfo) {
        restoreColorSelection(colorInfo);
      }

      // Scroll al inicio del producto - COMENTADO según solicitud del usuario
      // var $productContainer = $('.t4s-main-product__content');
      // if ($productContainer.length > 0) {
      //   $('html, body').animate({
      //     scrollTop: $productContainer.offset().top - 100
      //   }, 500);
      // }

      console.log('✅ Componentes del tema reinicializados');
    }, 200); // Aumentado a 200ms para dar más tiempo al DOM
  }

  /**
   * Restaura la selección del color después de cargar el producto
   * @param {object} colorInfo - Información del color que fue seleccionado
   */
  function restoreColorSelection(colorInfo) {
    if (!colorInfo) {
      return;
    }

    console.log('🎨 Restaurando selección de color:', colorInfo);

    // Buscar el swatch que coincida con el color seleccionado
    var $swatches = $('[data-swatch-item2]');
    var $selectedSwatch = null;

    $swatches.each(function () {
      var $swatch = $(this);
      var swatchColorNombre = $swatch.data('color-nombre') || $swatch.attr('data-color-nombre') || '';
      var swatchColorTexto = $swatch.data('color-texto') || $swatch.attr('data-color-texto') || '';
      var swatchValue = $swatch.data('value') || $swatch.attr('data-value') || '';
      var swatchProductUrl = $swatch.data('color-producto-url') || $swatch.attr('data-color-producto-url') || '';
      var swatchProductHandle = $swatch.data('color-producto-handle') || $swatch.attr('data-color-producto-handle') || '';

      // Comparar por nombre, texto, valor o URL del producto
      var matches = false;

      if (colorInfo.colorNombre && swatchColorNombre) {
        matches = matches || swatchColorNombre.toLowerCase() === colorInfo.colorNombre.toLowerCase();
      }

      if (colorInfo.colorTexto && swatchColorTexto) {
        matches = matches || swatchColorTexto.toLowerCase() === colorInfo.colorTexto.toLowerCase();
      }

      if (colorInfo.selectedValue && swatchValue) {
        matches = matches || swatchValue.toLowerCase() === colorInfo.selectedValue.toLowerCase();
      }

      // Si el producto actual coincide con el producto del swatch, seleccionarlo
      if (colorInfo.productUrl && swatchProductUrl) {
        matches = matches || swatchProductUrl === colorInfo.productUrl;
      }

      if (colorInfo.productHandle && swatchProductHandle) {
        matches = matches || swatchProductHandle === colorInfo.productHandle;
      }

      if (matches) {
        $selectedSwatch = $swatch;
        return false; // Salir del each
      }
    });

    if ($selectedSwatch && $selectedSwatch.length > 0) {
      // Obtener el contenedor de la opción del swatch
      var $swatchOption = $selectedSwatch.closest('[data-swatch-option2]');

      if ($swatchOption.length > 0) {
        // Remover selección anterior
        $swatchOption.find('[data-swatch-item2]').removeClass('is--selected');

        // Agregar selección al color encontrado
        $selectedSwatch.addClass('is--selected');

        // Actualizar el texto mostrado
        var displayText = colorInfo.colorNombre || colorInfo.selectedValue || colorInfo.colorTexto;
        $swatchOption.find('[data-current-value2]').text(displayText);
        $swatchOption.find('.t4s-dropdown__title').text(displayText);

        console.log('✅ Color restaurado y seleccionado:', displayText);
      } else {
        console.warn('⚠️ No se encontró el contenedor del swatch para restaurar la selección');
      }
    } else {
      console.warn('⚠️ No se encontró el color para restaurar la selección:', colorInfo);
    }
  }

})(jQuery);

